import React, { useState } from "react";
import CardLayout from "../../../common/cardLayout/CardLayout";
import RiskPill from "../../../common/RiskPill";
import {
  assessmentNameLookup,
  SDOHRiskLookup as riskLookup,
} from "../../../../constants/constants";
import PatientLoader from "../../../common/PatientLoader";
import { NoAssessments } from "./FlaggedJournals";
import { useSelector } from "react-redux";
import SingleAssessmentModal from "../Assessments/SingleAssessmentModal";

const ResultTile = ({
  risk,
  custom_text = null,
  custom_risk_text = null,
  classnames = "",
  styles = {},
}) => {
  const target = riskLookup[risk] || riskLookup["na"];
  return (
    <div
      style={{ gap: "5px", ...styles }}
      className={`d-flex justify-content-between py-2 ${classnames}`}
    >
      <div className="container-fluid d-flex" style={{ gap: "5px" }}>
        {/* TODO: Fix this damn dot */}
        {/* <Dot color={target["dot_color"]} /> */}
        <strong style={{ color: `${target.text_color}` }}>{custom_text}</strong>
      </div>
      <RiskPill
        type={target.pill_type}
        styles={{ padding: "10px 20px", width: "45%" }}
        custom_text={custom_risk_text ? custom_risk_text : target?.text}
        show_icon={false}
      />
    </div>
  );
};

const SDOHResults = (props) => {
  const [isModalOpen, setModalOpen] = useState(false);
  const { assessmentsLoading, assessmentsData, sdohLoading, sdohData } =
    useSelector((state) => state.assessment);
  return (
    <CardLayout
      className="col-sm-12 col-md-5 col-lg-5"
      style={{
        border: "8px solid transparent",
        boxSizing: "border-box",
        backgroundClip: "padding-box",
      }}
    >
      {sdohLoading || assessmentsLoading ? (
        <PatientLoader showText={false} />
      ) : (
        <div
          className="container-fluid p-4"
          style={{ height: props?.height || "50vh", overflowY: "scroll" }}
        >
          <SingleAssessmentModal
            modalIsOpen={isModalOpen}
            setModalOpen={setModalOpen}
            assessment={assessmentsData?.SDoH?.[0]}
            assessmentName={assessmentNameLookup["sdoh"]}
            flag={assessmentsData?.SDoH?.[0]?.flag}
          />
          <div className="d-flex justify-content-between mb-4 mt-2">
            <label style={{ fontSize: "1.3rem" }}>SDOH Results</label>
            {props?.showLinkButton ? (
              <small
                onClick={() => {
                  setModalOpen(true);
                }}
                to="/patients/results/sdoh"
                style={{
                  color: "#395e9d",
                  textDecoration: "underline",
                  cursor: "pointer",
                }}
              >
                View All {">"}
              </small>
            ) : (
              <></>
            )}
          </div>
          <div className="internal-scroll-container">
            <ul style={{ listStyleType: "none", paddingLeft: "0px" }}>
              {Object.entries(sdohData).length === 0 ? (
                <NoAssessments
                  text={`${
                    props?.first_name || "Patient"
                  } has not taken this assessment!`}
                  show_link={false}
                />
              ) : (
                <>
                  {Object.keys(sdohData).map((item, index) => {
                    return (
                      <li key={index}>
                        <ResultTile
                          risk={sdohData[item]?.flag?.toLowerCase() || "na"}
                          custom_text={item}
                        />
                      </li>
                    );
                  })}
                </>
              )}
            </ul>
          </div>
        </div>
      )}
    </CardLayout>
  );
};

export default SDOHResults;
